import React, { useEffect, useState } from "react";
import ReusableTable from "../../../../components/common/table";
import { Button, Popconfirm, Space } from "antd";
import { ReactComponent as AddSvg } from "../../../../assets/images/add.svg";
import FilterComponent from "../../../../components/common/filter";
import { useNavigate } from "react-router";
import ConfirmModal from "../../../../components/common/alert-popup";
import { ReactComponent as ViewSvg } from "../../../../assets/images/action/view.svg";
import { ReactComponent as DeleteSvg } from "../../../../assets/images/action/delete.svg";
import { ReactComponent as EditSvg } from "../../../../assets/images/action/edit.svg";
import { ReactComponent as DisableSvg } from "../../../../assets/images/action/Shield Cross.svg";
import CommonFilter from "../../../../components/common/filter";
import { useDispatch, useSelector } from "react-redux";
import {
  deletePodcast,
  listPodcasts,
  updatePodcast,
} from "../../../../redux/reducer/ManagePodcastSlice";
import dayjs from "dayjs";
import trimSearchValue, { useDebounce } from "../../../../customHooks";
import { useSearchParams } from "react-router-dom";
import { showData } from "../../../../customHooks";

const ManagePodcast = () => {
  const [filteredData, setFilteredData] = useState(null);
  const navigate = useNavigate();
  const [modalConfig, setModalConfig] = useState({
    open: false,
    actionType: "",
  });
  const [refereshData, setRefereshData] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [disableId, setDisableId] = useState(null);
  const [disableStatus, setDisableStatus] = useState(null);
  const dispatch = useDispatch();

  const [currentPage, setCurrentPage] = useState(1);
  const [searchParams, setSearchParams] = useSearchParams();
  // Convert URLSearchParams to usable object
  const getInitialParams = () => {
    const page = parseInt(searchParams.get("page")) || 1;
    const size = parseInt(searchParams.get("size")) || 10;
    const search_key = searchParams.get("search_key") || "all";
    const search_value = searchParams.get("search_value") || "";
    const status = searchParams.get("status");
    const position = searchParams.get("position");
    const from_date = searchParams.get("from_date");
    const to_date = searchParams.get("to_date");

    return {
      page,
      size,
      search_key,
      search_value,
      // from_date,
      // to_date,
      status: status !== null ? Number(status) : undefined,
      position: position !== null ? Number(position) : undefined,
    };
  };

  const [tableParams, setTableParams] = useState(getInitialParams());

  useEffect(() => {
    const params = {
      page: tableParams.page,
      size: tableParams.size,
      search_key: tableParams.search_key,
      search_value: tableParams.search_value,
    };

    if (tableParams.status !== undefined) params.status = tableParams.status;
    if (tableParams.position !== undefined)
      params.position = tableParams.position;
    if (tableParams.from_date !== undefined)
      params.from_date = tableParams.from_date;
    if (tableParams.to_date !== undefined) params.to_date = tableParams.to_date;

    setSearchParams(params);
  }, [tableParams, setSearchParams]);

  const { listPodcastsData, listPodcastsCount, listPodcastsLoading } =
    useSelector((prev) => prev?.managePodcast);

  const showModal = (actionType) => {
    setModalConfig({ open: true, actionType });
  };

  const debouncedSearchValue = useDebounce(tableParams.search_value, 500);

  useEffect(() => {
    dispatch(listPodcasts(trimSearchValue(tableParams)));
  }, [
    dispatch,
    refereshData,
    tableParams.page,
    tableParams.size,
    debouncedSearchValue,
    tableParams.status,
    tableParams.position,
    tableParams.from_date,
    tableParams.to_date,
  ]);

  const closeModal = () => {
    setModalConfig({ open: false, actionType: "" });
  };

  // pagination

  const paginationConfig = {
    pageSizeOptions: ["10", "20", "50"],
    showSizeChanger: true,
    showQuickJumper: true,
    total: listPodcastsCount || 1,
    current: tableParams.page,
    pageSize: tableParams.size,
    onChange: (page, pageSize) => {
      setCurrentPage(page);
      setTableParams((prev) => ({ ...prev, page, size: pageSize }));
    },
  };

  const handleTableChange = (pagination) => {
    setTableParams((prev) => ({
      ...prev,
      page: pagination.current,
      size: pagination.pageSize,
    }));
  };

  // pagination end

  const handleSearch = (searchText) => {
    const filtered = dataSource.filter((item) =>
      item.tenant_name.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredData(filtered);
  };

  const columns = [
    {
      title: "Sr. No.",
      dataIndex: "sr_no",
      key: "sr_no",
      render: (text, record, index) =>
        (tableParams.page - 1) * tableParams.size + index + 1,
      width: "100px",
    },
    {
      title: "Title",
      dataIndex: "title_en",
      key: "title",
      type: "search",
      render: (title_en, record) =>
      title_en ?? record?.title_es ?? record?.title_pt ?? "User"
   
    },
    // {
    //   title: "Star Rating",
    //   dataIndex: "title_en",
    //   key: "title",
    //   type: "search",
    //   render: (title_en) =>
    //     "Star"
    // },
    {
      title: "Image",
      dataIndex: "avg_rating",
      placeName: "Average Rating",
      key: "avg_Rating",
      type: "search",
      render: (book_cover_en, record) => (
        <div>
          {record?.book_cover_en || record?.book_cover_es || record?.book_cover_pt ? (
            <img
              src={`${process.env.REACT_APP_IMAGE_URL}/${record?.book_cover_en ?? record?.book_cover_es ?? record?.book_cover_pt}`}
              alt="Banner"
              style={{
                width: "100px",
                height: "50px",
                objectFit: "contain",
                borderRadius: "8px",
              }}
            />
          ) : (
            "No Image"
          )}
        </div>
      ),
    },
    // {
    //   title: "Short Description",
    //   dataIndex: "short_desc_en",
    //   key: "description",
    //   // type: "search",

    //   render: (short_desc_en) =>
    //     short_desc_en
    //       ? `${short_desc_en?.slice(0, 25)} ${
    //           short_desc_en?.length > 25 ? "..." : ""
    //         }`
    //       : "",
    // },

    {
      title: "Average Rating",
      dataIndex: "user_rating",
      placeName: "User Rating",
      key: "userRating",
      // type: "search",
      type: "search",
      width: "150px",
        render: (rating, record) =>
          record?.rating ??  "0",
    },
    {
      title: "Added On",
      dataIndex: "created_at",
      key: "date",
      type: "date",
      // render: (date) => dayjs(date).format("MM-DD-YYYY"),
      render: (date) => {
        const dateObject = new Date(date);
        const day = String(dateObject.getUTCDate()).padStart(2, "0");
        const month = String(dateObject.getUTCMonth() + 1).padStart(2, "0");
        const year = dateObject.getUTCFullYear();
        return `${month}-${day}-${year}`;
      },
    },
    // { title: "Added On", dataIndex: "added_on", key: "added_on", type: "date" },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      type: "select",
      render: (status) =>
        status === 1 ? (
          <p className="active-status">Active</p>
        ) : (
          <p className="inactive-status">Inactive</p>
        ), // Check if status is 1
      options: [
        { label: "Active", value: 1 },
        { label: "Inactive", value: 0 },
      ],
    },
  ];

  const dataSource = [
    {
      key: "1",
      sr_no: "1",
      title: "Acme Corp",
      description: "2024-01-01 - 2025-01-01",
      category: "contact@acme.com",
      status: "Active",
      added_on: "2024-02-15",
    },
    {
      key: "2",
      sr_no: "2",
      title: "Tech Solutions",
      description: "2023-05-10 - 2024-05-10",
      category: "info@techsolutions.com",
      status: "Inactive",
      added_on: "2023-05-10",
    },
    {
      key: "3",
      sr_no: "3",
      title: "Innovate Inc.",
      category: "2024-03-01 - 2025-03-01",
      email: "support@innovate.com",
      status: "Active",
      added_on: "2024-03-01",
    },
  ];

  const handleDeleteClick = (id) => {
    setDeleteId(id);
    showModal("delete"); // Open the modal
  };

  const handleConfirm = async () => {
    try {
      if (modalConfig.actionType === "delete" && deleteId) {
        await dispatch(deletePodcast(deleteId));
      } else if (modalConfig.actionType === "disable" && disableId) {
        await dispatch(
          updatePodcast({
            id: disableId,
            data: { status: 0, is_status_update: true },
          })
        );
      } else if (modalConfig.actionType === "enable") {
        await dispatch(
          updatePodcast({
            id: disableId,
            data: { status: 1, is_status_update: true },
          })
        );
      }
    } catch (error) {
      console.error("Action failed:", error);
    } finally {
      setRefereshData((prev) => !prev);
      setDisableId(null);
    }
    closeModal();
  };

  const handleDisableClick = (id, status) => {
    if (status === 1) {
      showModal("disable", id, status);
    } else if (status === 0) {
      showModal("enable", id, status);
    } else {
    }
    setDisableStatus(status);
    setDisableId(id);
    // showModal("disable"); // Open the modal for confirmation
  };

  const actionItems = (record) => [
    {
      key: "view",
      label: (
        <>
          <ViewSvg style={{ marginRight: 8 }} />
          View Details
        </>
      ),

      onClick: (record) =>
        navigate("view-podcast", { state: { celebrityData: record } }),
    },
    {
      key: "edit",
      label: (
        <>
          <EditSvg style={{ marginRight: 8, color: "red" }} />
          Edit Details
        </>
      ),
      // onClick: (record) => navigate("add-podcast"),
      onClick: (record) =>
        navigate("add-podcast", { state: { editData: record } }),
    },
    {
      key: "disable",
      label: (
        <>
          <DisableSvg
            style={{
              marginRight: 8,
              color: `${record.status === 1 ? "green" : "red"}`,
            }}
          />
          {record.status === 1 ? "Disable" : "Enable"}
        </>
      ),
      // onClick: () => showModal("disable"),
      onClick: (record) => handleDisableClick(record?.id, record?.status),
    },
    {
      key: "delete",
      label: (
        <>
          <DeleteSvg style={{ marginRight: 8, color: "red" }} />
          Delete Podcast
        </>
      ),
      // onClick: () => showModal("delete"),
      onClick: (record) => handleDeleteClick(record.id),
    },
  ];
  const handleFilterChange = (key, value, reset = false) => {
    setTableParams((prev) => {
      if (reset) {
        return {
          ...prev,
          page: 1,
          search_key: "",
          search_value: "",
          status: undefined,
          position: undefined,
        };
      }
      if (key === "created_at" && (!value || !value.from_date)) {
        return {
          size: prev.size,
          page: prev.page,
          // search_key: "",
        };
      }
      // if(key === "userRating"){
      //      return {
      //     ...prev,
      //     // page: 1,
      //     [key]: value,
      //     search_key: "",
      //     search_value: "",
      //   };
      // }
      if (key === "status" || key === "position") {
        return {
          ...prev,
          // page: 1,
          [key]: value,
          search_key: "",
          search_value: "",
        };
      }
      if (typeof value === "object" && value?.from_date) {
        return {
          ...prev,
          from_date: value.from_date,
          to_date: value.to_date,
          search_value: "",
          search_key: "",
          status: undefined,
          position: undefined,
        };
      }
      return {
        ...prev,
        search_key: key,
        search_value: value,
        status: undefined,
        position: undefined,
      };
    });
  };
  return (
    <div>
      <div className="addBx">
        <div className="filterBx">
          <Space>
            <CommonFilter
              columns={columns}
              onFilterChange={handleFilterChange}
              searchValue={tableParams.search_value}
            />
          </Space>
        </div>
        <Button
          type="primary"
          icon={<AddSvg />}
          onClick={() => navigate("add-podcast")}
        >
          Add Podcast
        </Button>
      </div>
      <div className="tableHeading">List of Podcasts Added</div>
      <ReusableTable
        columns={columns}
        dataSource={listPodcastsData}
        loading={listPodcastsLoading}
        paginationConfig={paginationConfig}
        onChange={handleTableChange}
        actionItems={(record) => actionItems(record)}
      />
      <ConfirmModal
        titlePrefix="Podcast"
        messagePrefix="Podcast"
        open={modalConfig.open}
        onClose={closeModal}
        onConfirm={handleConfirm}
        actionType={modalConfig.actionType}
      />
    </div>
  );
};

export default ManagePodcast;
